import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Link, Route } from 'react-router-dom';

class App extends Component {
  render() {
    return (
      <Router>
        <div className="App">

          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/support">Support</Link></li>
          </ul>

          <div className="App-header">

            <Route exact path="/" render={() => (
              <div>
                <h1>Panorama</h1>
                <h4>A little bit of perspective for your day.</h4>
              </div>
            )}/>

            <Route path="/support" render={() => (
              <div>
                <h3>Support</h3>
                <p>If you need help, email us at <a href="mailto:hello@samballantyne.com">hello@samballantyne.com</a></p>
              </div>
            )}/>

          </div>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js